var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-select',{staticClass:"ts-w-full",attrs:{"options":_vm.purchase,"showSearch":"","filterOption":(input, option) =>
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0},on:{"change":_vm.purchaseOrderChange},model:{value:(_vm.model.po_id),callback:function ($$v) {_vm.$set(_vm.model, "po_id", $$v)},expression:"model.po_id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }